import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { DELETE_ASSAY_MODAL } from "../../../actions/assays.js"; // Should take look
import DialogActions from "@material-ui/core/DialogActions";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";

const styles = {
  button: {
    backgroundColor: "#00a350",
  },
};

export class ModalDeleteAssay extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    modalInfo: PropTypes.object,
    actions: PropTypes.object,
    uniqueRowId: PropTypes.string,
  };

  handleClose = () => {
    const { actions } = this.props;
    actions.setAssayModalType(); // Need to take a look at it
    this.setState({
      selectedSku: false,
    });
  };

  handleDeleteMyAssay() {
    const { actions, uniqueRowId } = this.props;
    // Add the removeAssayfrom MyList
    actions.removeUserAssay(uniqueRowId);
    this.handleClose();
  }

  render() {
    const { classes, modalInfo, uniqueRowId } = this.props;
    const { modalType, uniqueAssayRowId } = modalInfo;

    return (
      <Dialog
        className="delete-modal"
        open={
          modalType === DELETE_ASSAY_MODAL && uniqueRowId === uniqueAssayRowId
        }
      >
        <DialogTitle className="delete-modal-message">
          Do you want to Delete this Assay?
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={() => this.handleDeleteMyAssay()}
            variant="contained"
            size="medium"
            className={classes.button}
          >
            Delete
          </Button>
          <Button
            onClick={() => this.handleClose()}
            variant="contained"
            size="medium"
            color="default"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const stateToProps = (state) => ({
  modalInfo: state && state.assays && state.assays.modalInfo,
});

ModalDeleteAssay = connect(stateToProps)(ModalDeleteAssay);

export default withStyles(styles)(ModalDeleteAssay);
